import QueryString from 'qs';
import sanitize from 'sanitize-html';

type Filter = {
  [key: string]: { [operator: string]: any };
};

type CategoryDetailQuery = {
  populate: {
    Products: {
      populate: {
        ItemDescriptionSetup: { populate: '*' };
        Grouping: { populate: '*' };
        Prices: { populate: '*' };
        ItemConfiguration: { populate: '*' };
        ProductGroupMembers: {
          populate: {
            Product: {
              populate: {
                Prices: { populate: '*' };
                Grouping: { populate: '*' };
                Categories: { populate: '*' };
                ItemDescriptionSetup: { populate: '*' };
                ItemConfiguration: { populate: '*' };
                ProductGroupMembers?: any;
              };
              filters?: Filter;
            };
          };
        };
        CategorySortOrders: { populate: '*' };
      };
      filters: Filter;
    };
    SubCategories: {
      populate: {
        Products: {
          populate: {
            ItemDescriptionSetup: { populate: '*' };
            Grouping: { populate: '*' };
            Prices: { populate: '*' };
            ItemConfiguration: { populate: '*' };
            ProductGroupMembers: {
              populate: {
                Product: {
                  populate: {
                    Prices: { populate: '*' };
                    Grouping: { populate: '*' };
                    Categories: { populate: '*' };
                    ItemDescriptionSetup: { populate: '*' };
                    ItemConfiguration: { populate: '*' };
                    ProductGroupMembers: any;
                  };
                  filters?: Filter;
                };
              };
            };
            CategorySortOrders: { populate: '*' };
          };
          filters: Filter;
        };
      };
      filters?: Filter;
    };
  };
  filters?: Filter;
};

const SoloProductBasicInformationQueryForDetialPage = {
  fields: ['ItemCode', 'Slug', 'publishedAt', 'TrustPilotLastSyncDate', 'ViewableOnWebsite'],
  populate: {
    ItemDescriptionSetup: {
      fields: [
        'ItemCode',
        'ItemName',
        'IdealForOrContains',
        'HowToUse',
        'ProductDescription',
        'ProductFacts',
        'Weight',
        'ProductVideo1',
        'ProductVideo2',
        'PromotionFeature',
        'FrequentlyAskedQuestions',
        'FoodTransitionInstructions',
        'FoodTransitionInstructionsForMobile',
        'SEOKeywords',
        'SEOMetadata',
        'Metadata',
        'PromotionPDF',
        'ItemPDF',
        'ShortProductDescription',
        'ShowIngredients',
        'ShowTrustpilotReviews',
      ],
      populate: {
        FeaturedIngredients: {
          populate: {
            Ingredients: {
              fields: ['Title', 'Description', 'publishedAt'],
              populate: {
                Image: {
                  fields: ['height', 'width', 'url'],
                },
                IngredientImage: {
                  fields: ['height', 'width', 'url'],
                },
              },
            },
          },
        },
        OtherIngredients: {
          populate: {
            Ingredients: {
              fields: ['Title', 'Description', 'publishedAt'],
              populate: {
                Image: {
                  fields: ['height', 'width', 'url'],
                },
                IngredientImage: {
                  fields: ['height', 'width', 'url'],
                },
              },
            },
          },
        },
        MainImage: {
          fields: ['url'],
          // populate: '*',
        },
        InvoiceImage: {
          fields: ['url'],
          // populate: '*',
        },
        SmallImage: {
          fields: ['url'],
          // populate: '*',
        },
        IconForPawClubPromotion: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage1: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage2: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage3: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage4: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage5: {
          fields: ['url'],
          // populate: '*',
        },
        AdditionalImage6: {
          fields: ['url'],
          // populate: '*',
        },
      },
    },
    ItemConfiguration: {
      fields: [
        'Color',
        'Size',
        'TruckIconFreeShippingQualified',
        'pawPointType',
        'PetCategory',
        'EZShipEligible',
        'EnrollmentItem',
        'EnrollmentProductPackEligible',
        'PointsIncrement',
        'OutOfStock',
      ],
      populate: '*',
    },
    Grouping: {
      populate: '*',
    },
    Prices: {
      populate: '*',
    },
  },
};

export const SoloProductQuery = QueryString.stringify({
  ...SoloProductBasicInformationQueryForDetialPage,
  populate: {
    ...SoloProductBasicInformationQueryForDetialPage.populate,
    ProductGroupMembers: {
      populate: {
        Product: {
          ...SoloProductBasicInformationQueryForDetialPage,
          populate: {
            ItemDescriptionSetup: {
              populate: {
                FeaturedIngredients: {
                  populate: {
                    Ingredients: {
                      populate: {
                        Image: true,
                      },
                    },
                  },
                },
                OtherIngredients: {
                  populate: {
                    Ingredients: {
                      populate: {
                        Image: true,
                      },
                    },
                  },
                },
                MainImage: {
                  populate: '*',
                },
                InvoiceImage: {
                  populate: '*',
                },
                SmallImage: {
                  populate: '*',
                },
                IconForPawClubPromotion: {
                  populate: '*',
                },
                AdditionalImage1: {
                  populate: '*',
                },
                AdditionalImage2: {
                  populate: '*',
                },
                AdditionalImage3: {
                  populate: '*',
                },
                AdditionalImage4: {
                  populate: '*',
                },
                AdditionalImage5: {
                  populate: '*',
                },
                AdditionalImage6: {
                  populate: '*',
                },
              },
            },
            ItemConfiguration: {
              populate: '*',
            },
            Categories: {
              populate: '*',
            },
            Prices: {
              populate: '*',
            },
            Grouping: {
              populate: '*',
            },
            ProductGroupMembers: {
              populate: {
                Product: {
                  ...SoloProductBasicInformationQueryForDetialPage,
                  populate: {
                    ItemDescriptionSetup: {
                      populate: {
                        FeaturedIngredients: {
                          populate: {
                            Ingredients: {
                              populate: {
                                Image: true,
                              },
                            },
                          },
                        },
                        OtherIngredients: {
                          populate: {
                            Ingredients: {
                              populate: {
                                Image: true,
                              },
                            },
                          },
                        },
                        MainImage: {
                          populate: '*',
                        },
                        InvoiceImage: {
                          populate: '*',
                        },
                        SmallImage: {
                          populate: '*',
                        },
                        IconForPawClubPromotion: {
                          populate: '*',
                        },
                        AdditionalImage1: {
                          populate: '*',
                        },
                        AdditionalImage2: {
                          populate: '*',
                        },
                        AdditionalImage3: {
                          populate: '*',
                        },
                        AdditionalImage4: {
                          populate: '*',
                        },
                        AdditionalImage5: {
                          populate: '*',
                        },
                        AdditionalImage6: {
                          populate: '*',
                        },
                      },
                    },
                    ItemConfiguration: {
                      populate: '*',
                    },
                    Categories: {
                      populate: '*',
                    },
                    Prices: {
                      populate: '*',
                    },
                    Grouping: {
                      populate: '*',
                    },
                  },
                  filters: {
                    publishedAt: {
                      $notNull: true,
                    },
                  },
                },
              },
            },
          },
          filters: {
            publishedAt: {
              $notNull: true,
            },
          },
        },
      },
    },
  },
  filters: {
    $and: [
      {
        publishedAt: {
          $notNull: true,
        },
      },
      {
        Categories: {
          id: {
            $notNull: true,
          },
        },
      },
    ],
  },
});

export const generateQueryStringToSeeIfThisProductBelongsToGroupMaster = (itemCode: string | number) =>
  QueryString.stringify({
    populate: {
      ProductGroupMembers: {
        populate: {
          Product: {
            populate: {
              Categories: {
                populate: '*',
                filters: {
                  id: {
                    $notNull: true,
                  },
                },
              },
            },
            filters: {
              publishedAt: {
                $notNull: true,
              },
            },
          },
        },
      },
    },
    filters: {
      ProductGroupMembers: {
        Product: {
          $or: [
            {
              ItemCode: {
                $in: [itemCode],
              },
            },
            {
              Slug: itemCode,
            },
          ],
        },
      },
      Categories: {
        id: {
          $notNull: true,
        },
      },
    },
  });

export const generateQueryStringToGetTotalNumberOfProductsInCategory = QueryString.stringify({
  populate: {
    Products: {
      fields: ['ItemCode'],
    },

    SubCategories: {
      populate: {
        Products: {
          fields: ['ItemCode'],
        },
      },
    },
  },
});

export const getCategoryDetailQueryWithFilters = (itemsCodes?: string[]) => {
  const categoryDetailQuery: CategoryDetailQuery = {
    populate: {
      Products: {
        populate: {
          ItemDescriptionSetup: { populate: '*' },
          Grouping: { populate: '*' },
          Prices: { populate: '*' },
          ItemConfiguration: { populate: '*' },
          ProductGroupMembers: {
            populate: {
              Product: {
                populate: {
                  Prices: { populate: '*' },
                  Grouping: { populate: '*' },
                  Categories: { populate: '*' },
                  ItemDescriptionSetup: { populate: '*' },
                  ItemConfiguration: { populate: '*' },
                  ProductGroupMembers: {
                    populate: {
                      Product: {
                        populate: {
                          ItemDescriptionSetup: {
                            populate: '*',
                          },
                          ItemConfiguration: {
                            populate: '*',
                          },
                          Categories: {
                            populate: '*',
                          },
                          Prices: {
                            populate: '*',
                          },
                          Grouping: {
                            populate: '*',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          CategorySortOrders: { populate: '*' },
        },
        filters: {
          publishedAt: {
            $notNull: true,
          },
        },
        // count: true,
      },

      SubCategories: {
        populate: {
          Products: {
            populate: {
              ItemDescriptionSetup: { populate: '*' },
              Grouping: { populate: '*' },
              Prices: { populate: '*' },
              ItemConfiguration: { populate: '*' },
              ProductGroupMembers: {
                populate: {
                  Product: {
                    populate: {
                      Prices: { populate: '*' },
                      Grouping: { populate: '*' },
                      Categories: { populate: '*' },
                      ItemDescriptionSetup: { populate: '*' },
                      ItemConfiguration: { populate: '*' },
                      ProductGroupMembers: {
                        populate: {
                          Product: {
                            populate: {
                              ItemDescriptionSetup: {
                                '[populate]': '*',
                              },
                              ItemConfiguration: {
                                '[populate]': '*',
                              },
                              Categories: {
                                '[populate]': '*',
                              },
                              Prices: {
                                '[populate]': '*',
                              },
                              Grouping: {
                                '[populate]': '*',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              CategorySortOrders: { populate: '*' },
            },
            filters: {
              publishedAt: {
                $notNull: true,
              },
            },
          },
        },
        filters: {
          publishedAt: {
            $notNull: true,
          },
        },
      },
    },
    filters: {
      $and: [
        {
          ViewableOnWebsite: {
            $ne: false,
          },
        },
        {
          publishedAt: {
            $notNull: true,
          },
        },
      ],
    },
  };

  if (itemsCodes && itemsCodes?.length) {
    const itemCodesFilter = {
      $in: [...itemsCodes],
    };

    categoryDetailQuery.populate.Products.filters['ItemCode'] = itemCodesFilter;
    categoryDetailQuery.populate.SubCategories.populate.Products.filters['ItemCode'] = itemCodesFilter;
  }

  return QueryString.stringify(categoryDetailQuery);
};

export const searchProducts = (q: string) => {
  const query = sanitize(q);

  return QueryString.stringify({
    populate: {
      ItemDescriptionSetup: {
        populate: '*',
      },
      ItemConfiguration: {
        populate: '*',
      },
      Categories: {
        populate: '*',
      },
      Grouping: {
        populate: '*',
      },
      Prices: {
        populate: '*',
      },
      ProductGroupMembers: {
        populate: {
          Product: {
            populate: {
              ItemDescriptionSetup: {
                '[populate]': '*',
              },
              ItemConfiguration: {
                '[populate]': '*',
              },
              Categories: {
                '[populate]': '*',
              },
              Prices: {
                '[populate]': '*',
              },
              Grouping: {
                '[populate]': '*',
              },
              ProductGroupMembers: {
                populate: {
                  Product: {
                    populate: {
                      ItemDescriptionSetup: {
                        '[populate]': '*',
                      },
                      ItemConfiguration: {
                        '[populate]': '*',
                      },
                      Categories: {
                        '[populate]': '*',
                      },
                      Prices: {
                        '[populate]': '*',
                      },
                      Grouping: {
                        '[populate]': '*',
                      },
                      ProductGroupMembers: {
                        populate: {
                          Product: {
                            populate: {
                              ItemDescriptionSetup: {
                                '[populate]': '*',
                              },
                              ItemConfiguration: {
                                '[populate]': '*',
                              },
                              Categories: {
                                '[populate]': '*',
                              },
                              Prices: {
                                '[populate]': '*',
                              },
                              Grouping: {
                                '[populate]': '*',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    filters: {
      $or: [
        {
          ItemDescriptionSetup: {
            KeyWordsForSearch: {
              $containsi: `${query}`,
            },
          },
        },
        {
          ItemDescriptionSetup: {
            ItemName: {
              $containsi: `${query}`,
            },
          },
        },
        {
          ItemDescriptionSetup: {
            ItemCode: {
              $containsi: `${query}`,
            },
          },
        },
      ],
      $and: [
        {
          publishedAt: {
            $notNull: true,
          },
        },
        {
          Categories: {
            id: {
              $notNull: true,
            },
          },
        },
        {
          ItemDescriptionSetup: {
            KeyWordsForSearch: {
              $containsi: `"visible": true`,
            },
          },
        },
      ],
    },
  });
};

const IngredientsPopulationObj = {
  populate: {
    Ingredients: {
      fields: ['Title', 'Description'],
      populate: {
        Image: {
          fields: ['height', 'width', 'url'],
        },
        IngredientImage: {
          fields: ['height', 'width', 'url'],
        },
      },
    },
  },
};

const SoloProductsPopulationObj = {
  fields: ['ItemName'],
  populate: {
    ItemDescriptionSetup: {
      fields: ['FeaturedIngredients', 'OtherIngredients'],
      populate: {
        FeaturedIngredients: IngredientsPopulationObj,
        OtherIngredients: IngredientsPopulationObj,
      },
    },
  },
};

const ProductsPopulationObj = {
  ...SoloProductsPopulationObj,
  populate: {
    ...SoloProductsPopulationObj.populate,
    ProductGroupMembers: {
      populate: {
        Product: SoloProductsPopulationObj,
      },
    },
  },
};

export const schema = {
  filters: {
    id: {
      $in: [625, 629, 631, 632, 633, 2236, 624],
    },
    Path: {
      $containsi: 'Replicated',
    },
  },
  pagination: {
    pageSize: 100,
  },
  fields: ['Name'],
  populate: {
    Products: ProductsPopulationObj,
    SubCategories: {
      fields: ['Name'],
      populate: {
        Products: ProductsPopulationObj,
      },
    },
  },
};
